import type Plans from '@alltrails/types/Plans';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const planSlice = createSlice({
  name: 'plans',
  initialState: {} as Plans,
  reducers: {
    setPlans: (_, action: PayloadAction<Plans>) => {
      return action.payload;
    }
  }
});

export const { setPlans } = planSlice.actions;

export default planSlice.reducer;
